export interface Tomo {
  num: string
  title: string
  range: string
}
export interface Bono {
  num: string
  name: string
  /** Beneficio en una línea. */
  role: string
}
export interface Faq {
  q: string
  a: string
}

/**
 * Formato monetario único de la landing: siempre "$00.000".
 */
export const PRICE = {
  previous: '$39.990',
  current: '$11.990',
  note: 'Pago único · Acceso digital inmediato',
} as const

/** Con información dispersa → Con las 200 fórmulas. */
export const TRANSFORM_BEFORE: string[] = [
  'Probás fórmulas sin saber si el resultado va a servir.',
  'Perdés materiales cuando algo sale mal.',
  'Tenés poca variedad para ofrecer.',
  'Te cuesta repetir exactamente un producto cuando te lo vuelven a pedir.',
]

export const TRANSFORM_AFTER: string[] = [
  'Elegís qué fabricar según el tipo de cliente o pedido.',
  'Trabajás con cantidades y procedimientos definidos.',
  'Ampliás tu catálogo sin experimentar desde cero.',
  'Podés repetir una fórmula cuando necesitás volver a producirla.',
]

/** Criterios con los que se elige qué fórmula fabricar dentro de la biblioteca. */
export const LIBRARY_CRITERIA: string[] = [
  'Dificultad',
  'Materiales',
  'Inversión',
  'Estilo',
  'Ocasión',
  'Producción en tandas',
  'Tipo de cliente',
  'Formato de venta',
]

/** Las 10 familias que agrupan las 200 fórmulas. */
export const CANDLE_FAMILIES: string[] = [
  'Soja & Contenedores',
  'Pilares, Moldes & Figuras',
  'Texturas Gourmet & Batidos',
  'Botánica Segura & Inclusiones',
  'Diseño de Autor & Acabados',
  'Bienestar, Spa & Masajes',
  'Souvenirs & Producción en Serie',
  'Velas de Estación & Tendencias',
  'Gran Formato & Exterior',
  'Especiales & Técnicas Mixtas',
]

/** Los 4 tomos de la colección. */
export const TOMOS: Tomo[] = [
  { num: '1', title: 'Velas en Contenedores', range: 'Fórmulas 001–050' },
  { num: '2', title: 'Moldes, Gourmet y Botánicas Seguras', range: 'Fórmulas 051–100' },
  { num: '3', title: 'Spa, Souvenirs y Velas de Estación', range: 'Fórmulas 101–150' },
  { num: '4', title: 'Velas XL, Exterior y Maestría Técnica', range: 'Fórmulas 151–200' },
]

/** Lo que contiene cada ficha de fórmula. */
export const FORMULA_FIELDS: string[] = [
  'Materiales',
  'Cantidades y proporciones',
  'Tipo o blend de cera',
  'Recipiente o molde',
  'Mecha / pabilo',
  'Fragancia y aditivos',
  'Temperaturas',
  'Paso a paso',
  'Terminación',
  'Test de combustión',
  'Errores y correcciones',
  'Consejo de venta',
]

/** Los 5 bonos incluidos gratis con la compra. */
export const BONOS: Bono[] = [
  {
    num: '1',
    name: 'Calculadora Express de Costos y Precio Base para Velas',
    role: 'Calculá bien. Ganá más.',
  },
  {
    num: '2',
    name: 'Mapa Rápido de Mechas y Test de Combustión',
    role: 'Mecha correcta. Quema perfecta.',
  },
  {
    num: '3',
    name: 'Botiquín Anti-Fallas: Diagnóstico Rápido para Velas que No Salen Bien',
    role: 'Problema → causa → solución.',
  },
  {
    num: '4',
    name: 'Catálogo Express: 50 Ideas de Velas, Packs y Souvenirs para Vender',
    role: 'Ideas listas para vender.',
  },
  {
    num: '5',
    name: 'Packaging Express: Cómo Hacer que tus Velas Parezcan Premium',
    role: 'Presentación que vende más.',
  },
]

/** Resumen corto de la oferta (no repetir la lista completa de contenidos). */
export const OFFER_INCLUDES: string[] = [
  '4 tomos digitales',
  '200 fórmulas paso a paso',
  '5 bonos de regalo',
  'Acceso digital inmediato',
]

export const FAQS: Faq[] = [
  {
    q: '¿Necesito experiencia haciendo velas?',
    a: 'No. El material empieza por los fundamentos y avanza hacia técnicas más elaboradas.',
  },
  {
    q: '¿Necesito equipamiento profesional?',
    a: 'No. Muchas fórmulas se resuelven con herramientas y materiales básicos de fabricación artesanal.',
  },
  {
    q: '¿Tengo que hacer las 200 fórmulas?',
    a: 'No. Funcionan como una biblioteca de consulta: elegís las que se adaptan a lo que querés fabricar.',
  },
  {
    q: '¿Los 5 bonos están incluidos?',
    a: 'Sí. Los 5 bonos vienen gratis con la compra, sin costo adicional.',
  },
  {
    q: '¿Cómo lo recibo?',
    a: 'Es un producto digital. Después de la compra recibís el acceso para descargar los 4 tomos y los bonos.',
  },
  {
    q: '¿El pago es único?',
    a: 'Sí. $11.990 ARS en un único pago, sin suscripciones.',
  },
]
